import common from "../common";

export default class Decoration extends PIXI.Container {
    constructor(textures) {
        super();
        this._altTextures = textures;
        this._curTexture = common.randomSelection(textures);
        this._lastSpawnPosition = null;
        this._isFollowing = false;
    }

    destroy(){

    }

    randomiseTexture(){
        this._curTexture = common.randomSelection(this._altTextures);
    }
}